import { render, staticRenderFns } from "./refundOrderItem2.vue?vue&type=template&id=eb45883e"
import script from "./refundOrderItem2.vue?vue&type=script&lang=js"
export * from "./refundOrderItem2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports